import { render, staticRenderFns } from "./SubMerchantLogin.vue?vue&type=template&id=5ebe1b9f&scoped=true&"
import script from "./SubMerchantLogin.vue?vue&type=script&lang=js&"
export * from "./SubMerchantLogin.vue?vue&type=script&lang=js&"
import style0 from "./SubMerchantLogin.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SubMerchantLogin.vue?vue&type=style&index=1&id=5ebe1b9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebe1b9f",
  null
  
)

export default component.exports